export default "__VITE_ASSET__UyhV7MKy__"